import * as React from 'react';

import kenco from '../assets/kenco-logo.png';

export default function KencoFlashLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return (
    <img
      src={kenco}
      alt='Kenco Flash'
      className='inline-block h-7 w-auto object-contain'
      {...props}
    />
  );
}
